import { DASHBOARD } from '../../../types/enum';
import userCircle from '../../../assets/svg/user-circle.svg';
import Title from '../../../components/dialog/title';

const Header = ({ title, user, currentSection, handleCurrentSection }) => {
  return (
    <div className='flex justify-between items-center'>
      {currentSection === DASHBOARD.HOME ? (
        <div className='flex items-center gap-2 mb-2'>
          <button
            className='size-11 rounded-full aspect-square flex items-center justify-center bg-tertiary border-[0.5px] border-tertiary overflow-hidden'
            onClick={handleCurrentSection(DASHBOARD.PERSONAL_INFO)}
          >
            <img
              src={user.profileUrl ?? userCircle}
              alt='profile'
              className='w-full h-full object-cover'
            />
          </button>
          <h1 className='text-xl font-bold text-white'>{title}</h1>
        </div>
      ) : (
        <Title
          title={title}
          onClick={handleCurrentSection(DASHBOARD.HOME)}
          color='white'
        />
      )}
    </div>
  );
};

export default Header;
